module.exports = __webpack_public_path__ + "static/India_Delivery_centre-aeb9491ef0b1e70086bb1e091a099bf1.png";